import "./style.css"
import { useState, useEffect } from "react"
import { ReactComponent as ArrowLeftIcon } from "assets/images/icons/arrow-left-black.svg"
import { ReactComponent as ArrowRightIcon } from "assets/images/icons/arrow-right-black.svg"
import { getDisplayRowPagination } from "./helper"
import SelectDefault from "components/Select/SelectDefault"

interface Props {
  queryState: {
    page: number
    limit: number
  }
  total: number
  handleChangePage: (newPage: number, newLimit: number) => void
  styleRoot?: React.CSSProperties
}
export const Pagination = (props: Props) => {
  const { total, queryState, handleChangePage, styleRoot } = props
  const [pageInput, setPageInput] = useState(queryState.page.toString())

  useEffect(() => {
    setPageInput(queryState.page.toString())
  }, [queryState.page])

  const totalPage = queryState?.limit
    ? Math.ceil(Number(total) / Number(queryState.limit))
    : 0

  const handleFirstPage = () => {
    if (queryState.page > 1) {
      handleChangePage(1, queryState.limit)
      setPageInput("1")
    }
  }

  const handlePreviousPage = () => {
    if (queryState.page > 1) {
      const newPage = queryState.page - 1
      handleChangePage(newPage, queryState.limit)
      setPageInput(newPage.toString())
    }
  }

  const handleNextPage = () => {
    if (queryState.page < totalPage) {
      const newPage = queryState.page + 1
      handleChangePage(newPage, queryState.limit)
      setPageInput(newPage.toString())
    }
  }

  const handleLastPage = () => {
    if (queryState.page < totalPage) {
      handleChangePage(totalPage, queryState.limit)
      setPageInput(totalPage.toString())
    }
  }

  const handlePageInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value
    setPageInput(value)
  }

  const handlePageInputBlur = () => {
    const pageNum = parseInt(pageInput, 10)
    if (pageNum >= 1 && pageNum <= totalPage) {
      handleChangePage(pageNum, queryState.limit)
    } else {
      setPageInput(queryState.page.toString())
    }
  }

  const handlePageInputKeyPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      handlePageInputBlur()
    }
  }

  const handleRowsPerPageChange = (data: { value: number; label: string }) => {
    if (data && Number(data.value) !== Number(queryState.limit)) {
      handleChangePage(1, Number(data.value))
      setPageInput("1")
    }
  }

  const pageOptions = [
    { label: "10/page", value: 10 },
    { label: "25/page", value: 25 },
    { label: "50/page", value: 50 },
    { label: "100/page", value: 100 },
  ]

  const selectedOption = pageOptions.find(
    (el) => el.value === queryState.limit
  ) || pageOptions[0]

  return (
    <div
      className="pagination-container"
      style={{
        flexWrap: "wrap",
        ...styleRoot,
      }}
    >
      <div className="pagination-section pagination-section-empty"></div>
      <div className="pagination-section pagination-section-controls">
        <div className="pagination-controls">
          <button
            className="pagination-btn pagination-btn-icon pagination-btn-first"
            onClick={handleFirstPage}
            disabled={queryState.page === 1}
            title="First page"
          >
            <ArrowLeftIcon />
            <ArrowLeftIcon />
          </button>
          <button
            className="pagination-btn pagination-btn-icon"
            onClick={handlePreviousPage}
            disabled={queryState.page === 1}
            title="Previous page"
          >
            <ArrowLeftIcon />
          </button>
          <div className="pagination-page-wrapper">
            <span className="pagination-page-label">Page :</span>
            <input
              type="text"
              className="pagination-page-input"
              value={pageInput}
              onChange={handlePageInputChange}
              onBlur={handlePageInputBlur}
              onKeyPress={handlePageInputKeyPress}
            />
            <span className="pagination-total-page">/ {totalPage}</span>
          </div>
          <button
            className="pagination-btn pagination-btn-icon"
            onClick={handleNextPage}
            disabled={queryState.page >= totalPage}
            title="Next page"
          >
            <ArrowRightIcon />
          </button>
          <button
            className="pagination-btn pagination-btn-icon pagination-btn-last"
            onClick={handleLastPage}
            disabled={queryState.page >= totalPage}
            title="Last page"
          >
            <ArrowRightIcon />
            <ArrowRightIcon />
          </button>
        </div>
      </div>
      <div className="pagination-section pagination-section-right flex items-center">
        <p
          className="text-[#7A7A7A] mr-[12px] pagination-info-text"
          style={{
            whiteSpace: "nowrap",
          }}
        >{`${getDisplayRowPagination(
          Number(queryState.page),
          Number(queryState.limit),
          total
        )} of ${total}`}</p>
        <SelectDefault
          options={pageOptions}
          selectedOption={selectedOption}
          handleChange={handleRowsPerPageChange}
          filed="value"
          rootClasses="h-[32px] rounded border-select flex items-center bg-[#FFFFFF] pagination-select"
          controlWidth={100}
          menuPlacement="bottom"
          menuStyle={{
            marginTop: 12,
          }}
        />
      </div>
    </div>
  )
}
